<template> 
  <div class="main-login">
    <div>
      <div
        align="center"
        class="mb-5">
        <img src="../../assets/img/logo-fb.png" width="60%">
      </div>
      <div class="card">
        <div class="card-body">
          <div class="p-3">
            <router-view />
          </div>
        </div>
      </div>
      <div
        class="mt-5"
        align="center">
        <a href="https://www.quickin.io/politica-de-privacidade/">{{ $t('Privacy Policy') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Auth',
  components: {
  },
  data () {
    return {
    }
  },
  metaInfo () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-login{
  max-width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('~@/assets/img/background-clean.jpg') center center;
  background-size: cover;
}
  .main-login > *{
    width: 100%;
    max-width: 380px;
    padding: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Auth/Auth.vue